export default "__VITE_ASSET__CAPHADb$__"